<div
  lpDraggable
  [dragPivot]="pivot()"
  [dragRoot]="this.context().el.nativeElement"
  dragMode="MANUAL"
  (draggableChangedPosition)="onPositionUpdated($event)"
  (draggableChangedStyle)="onStyleUpdated($event)"
  (draggableGrabbed)="onGrabbed()"
  (draggableReleased)="onReleased()"
  (draggableTargetEntered)="onTargetEntered()"
  style="position: relative; width: 100%; height: 100%"
>
  @if (isDragging()) {
    <lp-canvas-components [components]="comp().whileDragging ?? []" [context]="context()" />
  }
</div>
